var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.88389C13.4882 8.88389 13.8839 8.48816 13.8839 8.00001C13.8839 7.51185 13.4882 7.11612 13 7.11612V8.88389ZM3 7.11612C2.51184 7.11612 2.11612 7.51185 2.11612 8.00001C2.11612 8.48816 2.51184 8.88389 3 8.88389V7.11612ZM8.88389 3C8.88389 2.51184 8.48816 2.11612 8.00001 2.11612C7.51185 2.11612 7.11612 2.51184 7.11612 3H8.88389ZM7.11612 13C7.11612 13.4882 7.51185 13.8839 8.00001 13.8839C8.48816 13.8839 8.88389 13.4882 8.88389 13H7.11612ZM13 7.11612H3V8.88389H13V7.11612ZM7.11612 3V13H8.88389V3H7.11612Z",
    fill: "#1B1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSign);
export default __webpack_public_path__ + "static/media/plus-sign.33664c97f612318b5fb43d032ae62b23.svg";
export { ForwardRef as ReactComponent };